import React from 'react';

import ExportCharterDepartureManifestForm from '../Common/Forms/ExportCharterDepartureManifestForm';
import ExportCharterDeparturePassengerManifestForm from '../Common/Forms/ExportCharterDeparturePassengerManifestForm';
import ExportFlightBookingsForm from '../Common/Forms/ExportFlightBookingsForm';
import ExportFlightRefundsForm from '../Common/Forms/ExportFlightRefundsForm';

import ContentWithSidebar from './ContentWithSidebar';

const DEFAULT_ITEMS = 'flight-bookings';

export const items = [
  {
    slug: 'flight-bookings',
    title: 'Flight Bookings Report',
    component: ExportFlightBookingsForm,
  },
  {
    slug: 'flight-refunds',
    title: 'Flight Refunds Report (Work in progress)',
    component: ExportFlightRefundsForm,
  },
  {
    slug: 'charter-departure-manifest',
    title: 'Charter Departure Manifest',
    component: ExportCharterDepartureManifestForm,
  },
  {
    slug: 'charter-departure-passenger-manifest',
    title: 'Charter Departure Passenger Manifest',
    component: ExportCharterDeparturePassengerManifestForm,
  },
];

export default function FlightPage() {
  return <ContentWithSidebar items={items} defaultItem={DEFAULT_ITEMS} />;
}
